import React from 'react';
import { cn } from '../lib/utils';

const StatsCard = ({ 
  title, 
  value, 
  change, 
  changeType = 'neutral',
  icon: Icon,
  className 
}) => {
  const getChangeColor = () => {
    switch (changeType) {
      case 'positive':
        return 'text-green-600';
      case 'negative':
        return 'text-red-600';
      default:
        return 'text-gray-600';
    }
  };

  return (
    <div className={cn(
      "bg-white rounded-xl border border-gray-200 p-3 sm:p-6 hover:shadow-lg transition-all duration-200 group",
      "bg-gradient-to-br from-white to-gray-50/50",
      className
    )}>
      <div className="flex items-center justify-between gap-2">
        <div className="flex-1 min-w-0">
          <p className="text-xs sm:text-sm font-medium text-gray-600 mb-0.5 sm:mb-1 truncate">
            {title}
          </p>
          <h3 className="text-lg sm:text-2xl font-bold text-gray-900 mb-1 sm:mb-2 truncate">
            {value}
          </h3>
          {change && (
            <p className={cn("text-xs sm:text-sm font-medium truncate", getChangeColor())}>
              {change}
            </p>
          )}
        </div>
        {Icon && (
          <div className="flex-shrink-0">
            <div className="w-8 h-8 sm:w-12 sm:h-12 bg-blue-50 rounded-lg flex items-center justify-center group-hover:bg-blue-100 transition-colors">
              <Icon className="w-4 h-4 sm:w-6 sm:h-6 text-blue-600" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatsCard;
